// Single source of truth for categories across the app
export const CATEGORIES = [
  "Meals & entertainment",
  "Travel",
  "Office supplies",
  "Vehicle expenses",
  "Fuel",
  "Tools",
  "Home office",
  "Phone/Internet",
  "Repairs",
  "Inventory",
  "Software",
  "Non-Deductible",
  "Other"
] as const;

export type Category = typeof CATEGORIES[number];

/**
 * Single confidence threshold used everywhere to decide needs_review.
 * Value is on a 0-1 decimal scale.
 * Receipts with confidence_score < this value are flagged for review.
 */
export const CONFIDENCE_THRESHOLD = 0.75;
